export default __webpack_public_path__ + "static/media/users_icon.6bc13180.svg";